"use client";
import { avenirNextRegular } from "@/styles/fonts";
import { useEffect, useState } from "react";

export default function AdBlockDetectedWrapper() {
    const [adBlockDetected, setAdBlockDetected] = useState(false);

    useEffect(() => {
        const bait = document.createElement("script");
        bait.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
        bait.style.display = "none";
        document.body.appendChild(bait);

        bait.onerror = () => {
            setAdBlockDetected(true);
        };

        // Clean up the bait element after checking
        return () => {
            document.body.removeChild(bait);
        };
    }, []);


    if (adBlockDetected) {
        return (
            <div className={`
                ${avenirNextRegular.className}
                flex 
                flex-row 
                justify-center
                items-center
                text-center p-4`}>
                <p className="text-lg mr-4">
                    We noticed that you have an ad blocker enabled. Please consider disabling it to ensure optimal experience.
                </p>
                <button
                    onClick={() => window.location.reload()}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
                >
                    Refresh Page
                </button>
            </div>
        );
    }

    return null;
}